
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skipaesse",
      function () {
        return require("private-next-pages/[region]/skipaesse.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skipaesse"])
      });
    }
  